import React from 'react'
import { connect } from 'react-redux'
import { isEmpty } from 'lodash'
import { Grid, Container, Card, CardContent, Typography, CircularProgress, Button, Chip } from '@material-ui/core'
import { addToCart, removeFromCart } from '../../actions/userAction'
import { makeStyles } from '@material-ui/core/styles';
import AddOnModal from './AddOnModal'
import Mark from './Mark'
import FancyButton from './FancyButton'

const useStyles = makeStyles((theme) => ({
    div: {
        width: '100%',
        marginTop: theme.spacing(8),
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        overflow: "hidden"
    },
    cardContent: {
        paddingTop: 0
    },
    marginTop: {
        marginTop: theme.spacing(4)
    },
    marginTopSm: {
        marginTop: theme.spacing(2)
    },
    marginBottomSm: {
        marginBottom: theme.spacing(2)
    },
    img: {
        width: "100%",
        height: "auto"
    }

}));

const Page = (props) => {
    const { foodItem, isLoading, cartChangeToken, nearestOutletMenu, cart, cartLoading } = props
    // console.log(foodItem)
    const classes = useStyles();

    const [isModalOpen, toggle] = React.useState(false)

    React.useEffect(() => {
        window.scrollTo(0, 0)
    }, [])


    function _addToCart({ addOns = {}, priceWithAddons = 0 }) {
        const { foodItem, addToCart } = props
        const item = {}
        item["id"] = foodItem.id
        item["title"] = foodItem.title
        item["price"] = foodItem.offerPrice
        item["totalPrice"] = parseInt(foodItem.offerPrice) + parseInt(priceWithAddons)
        item["customization"] = addOns
        addToCart(item)
    }

    function _removeFromCart({ itemId, configId }) {
        const { removeFromCart } = props
        console.log({ itemId, configId });
        removeFromCart({ itemId, configId })
    }

    function renderButton() {

        if (foodItem.isDisabled) return <Button disabled>Not Available</Button>

        if (nearestOutletMenu) {
            const isAvailable = nearestOutletMenu.menu[foodItem.id].isAvailable
            if (!isAvailable) return <Button disabled>Not Available</Button>
        }


        return (
            <div>
                {
                    foodItem.customization.length > 0 ?
                        <>
                            <FancyButton
                                foodItem={foodItem}
                                cart={cart}
                                cartChangeToken={cartChangeToken}
                                cartLoading={cartLoading}
                                leftClick={_removeFromCart}
                                rightClick={() => toggle(true)}
                                customization={foodItem.customization.length > 0}
                                style={{ textAlign: 'left' }}
                            />

                            <AddOnModal
                                isOpen={isModalOpen}
                                foodItem={foodItem}
                                onClose={() => toggle(false)}
                                _addToCart={_addToCart}
                                customization={foodItem.customization.length > 0}
                            />
                        </>
                        :

                        <FancyButton
                            foodItem={foodItem}
                            cart={cart}
                            cartChangeToken={cartChangeToken}
                            cartLoading={cartLoading}
                            leftClick={_removeFromCart}
                            rightClick={_addToCart}
                            style={{ textAlign: 'left' }}
                        />
                }
            </div>
        )


    }

    if (isLoading) {
        return (
            <Container>
                <div className={classes.div}>
                    <CircularProgress />
                </div>
            </Container>
        )
    }

    return (
        <Container className={classes.marginTop}>
            <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                    <img className={classes.img} src={foodItem.imageUrl} alt={foodItem.title} />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <Card>
                        <CardContent className={classes.cardContent}>
                            <Chip label={`Serves : ${foodItem.servings}`} variant="outlined" color="primary" />
                            <Typography aria-label={foodItem.title} component="p" variant="h5" align="left" color="primary">
                                <span style={{ textTransform: 'capitalize' }}> {foodItem.title.toLowerCase()}</span>
                            </Typography>
                            <Mark foodLabel={foodItem.label} type={foodItem.type} />

                            <Typography aria-label={foodItem.offerPrice} component="p" variant="h6" align="left" color="primary"
                                className={`${classes.marginBottomSm} ${classes.marginTopSm}`} >
                                {foodItem.offerPrice < foodItem.price ?
                                    <React.Fragment>
                                        <span>₹  <span style={{ textDecoration: 'line-through' }}>{foodItem.price}</span>  {foodItem.offerPrice}</span>
                                    </React.Fragment>
                                    :
                                    <span>₹ {foodItem.offerPrice}</span>
                                }
                            </Typography>

                            <div className={classes.marginBottomSm}>
                                {renderButton()}
                            </div>


                            <div className={classes.marginBottomSm}>
                                <Typography component="p" variant="h6" align="left" color="textSecondary">
                                    DETAILS ABOUT THIS MEAL
                                </Typography>

                                <Typography component="p" variant="body1" align="left" color="primary">
                                    {foodItem.details}
                                </Typography>
                            </div>

                            {/* ingredients div here */}
                            {
                                foodItem.ingredients.length > 0 && (
                                    <div className={classes.marginBottomSm}>
                                        <Typography component="p" variant="h6" align="left" color="textSecondary">
                                            INGREDIENTS
                                        </Typography>

                                        {
                                            foodItem.ingredients.map((ing, index) => {
                                                return (
                                                    <Typography component="span" variant="body1" align="left" color="primary" key={ing.value}>
                                                        {ing.label}{index <= foodItem.ingredients.length - 2 && ', '}
                                                    </Typography>
                                                )
                                            })
                                        }
                                    </div>
                                )
                            }

                            {/* nutrition facts div here */}
                            {
                                foodItem.nutritionFacts.length > 0 && (
                                    <div className={classes.marginBottomSm}>
                                        <Typography component="p" variant="h6" align="left" color="textSecondary">
                                            NUTRITION
                                        </Typography>
                                        <Grid container spacing={4}>
                                            {
                                                foodItem.nutritionFacts.map((nut, index) => {
                                                    return (
                                                        <Grid item key={nut.id}>
                                                            <Typography component="p" variant="h6" align="center" color="primary" >
                                                                {nut.value}
                                                            </Typography>
                                                            <Typography component="p" variant="body1" align="center" color="primary">
                                                                {nut.name}
                                                            </Typography>
                                                        </Grid>
                                                    )
                                                })
                                            }
                                        </Grid>
                                    </div>
                                )
                            }

                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
        </Container >
    )
}

const mapStateToProps = (state, ownProps) => {

    const id = ownProps.match.params.id
    const menu = state.menu
    let foodItem
    let isLoading = true

    const { outlets } = state
    const { nearestOutlet } = state.meta

    const nearestOutletMenu = outlets[nearestOutlet.id]


    if (!isEmpty(menu) && menu.hasOwnProperty(id)) {
        foodItem = menu[id]
        isLoading = false
    } else if (!isEmpty(menu) && !menu.hasOwnProperty(id)) {
        window.location.href = '/'
    }

    return {
        isLoading,
        foodItem,
        cart: state.user.cart,
        cartChangeToken: state.user.cartChangeToken,
        cartLoading: state.user.cartLoading,
        nearestOutletMenu: nearestOutletMenu
    }
}

export default connect(mapStateToProps, { addToCart, removeFromCart })(Page)